import {
  colorBlue300,
  colorForest100,
  colorForest400,
  colorRed500,
} from "@amzn/meridian-tokens/base/color";
import documentTokens from "@amzn/meridian-tokens/base/icon/document";
import downloadTokens from "@amzn/meridian-tokens/base/icon/download-large";
import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import Divider from "@amzn/meridian/divider";
import Icon from "@amzn/meridian/icon";
import Modal from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Text from "@amzn/meridian/text";
import { css } from "@emotion/css";
import React, { useEffect, useState } from "react";
import {
  BatchExtractionJobView,
  BatchJobStatus,
  getPreSignUrlAndDownload,
  resetNewCreatedBatchJobId,
} from "src/store/batchExtractionSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { convertSeconds, timeAgo } from "src/utils/dateUtil";
import "./batchJobView.scss";
import Loader from "@amzn/meridian/loader";
import { useNavigate } from "react-router-dom";

const blueText = css({
  color: colorBlue300,
});

const greenText = css({
  color: colorForest400,
});

const redText = css({
  color: colorRed500,
});

const BatchJobView = () => {
  const { batchJobs, newCreatedBatchJobId } = useAppSelector((state) => state.batchExtractionSlice);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (newCreatedBatchJobId !== "") {
      setTimeout(() => {
        dispatch(resetNewCreatedBatchJobId());
      }, 5000);
    }
  }, [newCreatedBatchJobId]);

  const getJobStatusComponent = (batchJob: BatchExtractionJobView) => {
    if (batchJob.status === BatchJobStatus.Completed) {
      return (
        <Column>
          <Button
            type={"secondary"}
            submit={true}
            onClick={() =>
              dispatch(
                getPreSignUrlAndDownload({
                  jobId: batchJob.id,
                  s3URL: batchJob.s3OutputFilePath,
                  fileName: batchJob.s3OutputFilePath.replace("output/", ""),
                }),
              )
            }
          >
            <Icon tokens={downloadTokens} />
            Download
          </Button>
          {batchJob.totalLines > 0 && (
            <Button
              type={"secondary"}
              submit={true}
              onClick={() => navigate(`/batchProcess/${batchJob.id}`)}
            >
              View Extracted Record
            </Button>
          )}
        </Column>
      );
    } else if (batchJob.status === BatchJobStatus.Processing) {
      return (
        <Column>
          <Text className={greenText}>In progress...</Text>
          <Loader
            type="linear"
            percentage={(batchJob.linesProcessed / batchJob.totalLines) * 100}
          ></Loader>
        </Column>
      );
    } else if (batchJob.status === BatchJobStatus.Error) {
      return <Text className={redText}>Extraction error, please try again...</Text>;
    } else {
      return <></>;
    }
  };

  return (
    <Column spacing={"400"}>
      <Row width="100%" alignmentHorizontal={"start"}>
        <Text fontFamily="bookerly" type={"d50"}>
          Your extraction jobs
        </Text>
      </Row>
      <Row></Row>
      {batchJobs.map((batchJob) => (
        <>
          <Divider spacingAfter="large" spacingBefore="large" />
          <Row
            alignmentHorizontal={"start"}
            widths={["30%", "30%", "40%"]}
            width={"100%"}
            backgroundColor={batchJob.id === newCreatedBatchJobId ? colorForest100 : ""}
          >
            <Column alignmentVertical={"top"} spacing={"100"}>
              <span className="filename-truncate">
                <Text type={"h200"}>
                  <Icon className={blueText} tokens={documentTokens} />
                  {" " + batchJob.inputFileName}
                </Text>
              </span>
              <Row widths={["8%"]}>
                <Column></Column>
                <Text color={"secondary"}>{timeAgo(batchJob.creationTimestamp)}</Text>
              </Row>
            </Column>
            <Column alignmentVertical={"top"} alignmentHorizontal={"start"}>
              <Text>{batchJob.modelName}</Text>
              {batchJob.status === BatchJobStatus.Completed && (
                <Row alignmentHorizontal={"start"} width={"100%"}>
                  <Text>Process time : </Text>
                  <Text>{convertSeconds(Number(batchJob.processingTimeInSeconds))}</Text>
                </Row>
              )}
            </Column>
            <Column alignmentVertical={"top"} alignmentHorizontal={"center"} spacing={"100"}>
              {getJobStatusComponent(batchJob)}
              {/* will enable this section after backend feed accuracy data */}
              {/*{batchJob.accuracy && Object.keys(batchJob.accuracy).length > 0 &&*/}
              {/*    <Row alignmentHorizontal={"center"} width={"100%"}>*/}
              {/*        {getExtractionAccuracyModal(batchJob)}*/}
              {/*    </Row>*/}
              {/*}*/}
            </Column>
          </Row>
        </>
      ))}
    </Column>
  );
};
export default BatchJobView;
